var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Period } from '@/models/Period';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import AddPeriodDialog from '@/views/Periods/AddPeriodDialog';
import { activeHtml } from '@/support/String';
import { formatDate as format } from '@/support/String';
import ErrorHandler from '@/support/ErrorHandler';
import { excludeRoles } from '@/support/ExcludeRoles';
let Periods = class Periods extends Vue {
    constructor() {
        super(...arguments);
        this.selected = [];
        this.periods = null;
        this.selectedPeriod = null;
        this.isCreatingPeriod = false;
        this.visibility = {
            search: false,
            total: false,
            limit: false,
            pagination: false,
            checkboxes: false,
        };
    }
    get maxDate() {
        if (!this.year) {
            return '';
        }
        return this.year.ends_at;
    }
    get minDate() {
        if (!this.year) {
            return '';
        }
        return this.year.starts_at;
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('period.title', 1),
                plural: this.$tc('period.title', 2),
            },
            headers: this.tableHeaders,
            actions: [
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, period) => {
                        this.selectedPeriod = period;
                        this.$store.dispatch('openDialog', this.dialogOptions);
                    },
                },
            ],
            filters: [],
            model: new Period().filter('years', this.year || null),
        };
    }
    get dialogOptions() {
        const period = this.selectedPeriod;
        return {
            title: period.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, { item: this.$t('dialogOptions.item.period') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!period) {
                            return;
                        }
                        period
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedPeriod = new Period();
                                this.refreshDataTable();
                                this.fetchPeriods();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedPeriod = new Period();
                    },
                },
            },
        };
    }
    get tableHeaders() {
        const headers = [
            {
                text: this.$t('name.title'),
                value: 'name',
                editable: true,
                changed: false,
                transform: (name, period) => (period.is_current && !this.exclude ? activeHtml(name) : name),
            },
            {
                text: this.$t('value.title'),
                value: 'value',
                editable: true,
                changed: false,
                sortable: {
                    key: 'sequence',
                    order: 'ASC',
                },
            },
        ];
        const tableDates = [{
                text: this.$t('starts.title'),
                type: 'date',
                modal: false,
                min: this.minDate,
                value: 'starts_at',
                editable: true,
                changed: false,
                transform: (date) => {
                    return format(date, 'yyyy-LL-dd');
                },
            },
            {
                text: this.$t('ends.title'),
                type: 'date',
                modal: false,
                value: 'ends_at',
                max: this.maxDate,
                editable: true,
                changed: false,
                transform: (date) => {
                    return format(date, 'yyyy-LL-dd');
                },
            }];
        if (!this.exclude) {
            return [...headers, ...tableDates];
        }
        return headers;
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolAdmin.years.date.includes(this.$store.state.Auth.roles[0].id);
    }
    mounted() {
        this.$pageTitle = this.$tc('period.title', 2);
        this.fetchPeriods();
    }
    refreshFilterStore() {
        if (this.year && !this.year.is_current) {
            return;
        }
        new Period()
            .filter('years', this.year || null)
            .all()
            .then((periods) => {
            const mutatedPeriods = [];
            const payload = {};
            periods.forEach((period) => {
                mutatedPeriods.push({
                    value: period.id,
                    text: period.getFilterLabel(),
                });
            });
            payload.Period = mutatedPeriods;
            this.$store.dispatch('updateFilters', payload);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    refreshDataTable() {
        this.refreshFilterStore();
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
        this.fetchPeriods();
    }
    fetchPeriods() {
        new Period()
            .filter('years', this.year || null)
            .all()
            .then((periods) => {
            this.periods = periods;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Object)
], Periods.prototype, "year", void 0);
Periods = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            AddPeriodDialog,
        },
    })
], Periods);
export default Periods;
